export default __webpack_public_path__ + "static/media/warning.2890e75c.svg";